import Vuex from 'vuex'
import Vue from 'vue'
import auth from './module/auth'
import application from './module/application'
import notification from './module/notification'


Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
        auth,
        application,
        notification
    }
});